import { Injectable } from '@angular/core';
import { BehaviorSubject, EMPTY, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SubSink } from 'subsink';
import { AutoUnsubscribe } from '../../../core/auto-unsubscribe';
import { RequestProductDto, RequestsXatSvc } from '../../../xatena-api';

@AutoUnsubscribe()
@Injectable({
  providedIn: 'root',
})
export class RequestProductDeleteDialogService {
  subs = new SubSink();

  key?: {
    requestId?: number;
    requestProductId?: number;
  };

  model$ = new BehaviorSubject<RequestProductDto | null>(null);

  constructor(private requestService: RequestsXatSvc) {}

  loadProduct(): Observable<void> {
    if (this.key && this.key.requestId && this.key.requestProductId)
      return this.requestService
        .getRequestProduct(this.key.requestId, this.key.requestProductId)
        .pipe(
          map(m => {
            this.model$.next(m);
          })
        );

    this.model$.next({
      requestId: this.key?.requestId,
    } as RequestProductDto);

    return EMPTY;
  }

  removeProduct(): Observable<void> {
    if (
      this.key &&
      this.key.requestId &&
      this.key.requestProductId &&
      this.model$.value
    )
      return this.requestService.removeRequestProduct(
        this.key.requestId,
        this.key.requestProductId,
        this.model$.value
      );

    return EMPTY;
  }
}
